/* PAVENROD - parcours d'achat (octobre 2026). Charge par la section PAV - Socle.
   1. Taille a choisir. Sur une fiche ouverte sans variante dans l'adresse, Eclipse coche la
      premiere taille disponible : le client pouvait ajouter un XS sans l'avoir choisi (vu au test
      du 17 octobre avec le module pack). Ici, aucune taille n'apparait choisie tant que le client
      n'en a pas clique une ; l'ajout au panier (bouton principal, barre fixe, apercu rapide des
      collections, modules pack et tenue de la fiche) est alors arrete et un message s'affiche
      sous le selecteur. La variante cochee par Eclipse reste en place : un clic sur une taille, y
      compris celle-la, suffit. Reglages et textes : section PAV - Socle (groupe d'en-tete).
   2. Alerte de retour en stock par taille. Le bloc d'alerte de la fiche (bloc Liquid du gabarit
      produit, data-pv-attente) est rendu masque quand le produit reste disponible ; il s'affiche
      quand la taille choisie est epuisee, avec la taille dans son titre et dans les etiquettes
      du client (taille-xl), pour pouvoir prevenir les bonnes personnes au reassort.
   Sans ce script, la fiche garde le comportement d'Eclipse. */
(function () {
  'use strict';
  var doc = document;
  var cfg = {};
  try {
    var cfgEl = doc.getElementById('pv-parcours-cfg');
    cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
  } catch (e) { cfg = {}; }
  var T = cfg.taille || {};

  function norm(s) { return String(s || '').toLowerCase().replace(/[:\s]+/g, ' ').trim(); }
  function slug(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/\p{M}/gu, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }
  function aVariante() { return /[?&]variant=\d+/.test(location.search); }

  /* ---------- 1. Taille a choisir ---------- */
  var noms = String(T.options || 'Taille').split(',').map(norm).filter(Boolean);
  var principaleChoisie = aVariante();

  function estGroupeTaille(g) {
    if (!g) { return false; }
    var lab = g.querySelector('.label-text');
    if (!lab || noms.indexOf(norm(lab.textContent)) === -1) { return false; }
    return g.querySelectorAll('[js-variant-input]').length >= 2;
  }
  /* selecteurs de taille d'une fiche : celui de la page et, sur la barre d'achat fixe, la copie
     qu'Eclipse en fait dans sa fenetre de choix */
  function groupesTaille(section) {
    var out = [];
    var gs = section.querySelectorAll('[js-variant-group-container]');
    for (var i = 0; i < gs.length; i++) { if (estGroupeTaille(gs[i])) { out.push(gs[i]); } }
    return out;
  }
  function groupeTaille(section) {
    var gs = groupesTaille(section);
    for (var i = 0; i < gs.length; i++) { if (!closest(gs[i], '[js-sticky-atc]')) { return gs[i]; } }
    return gs.length ? gs[0] : null;
  }
  function estApercu(section) { return section.getAttribute('data-section-type') === 'quick-view-product'; }
  function enAttente(section) { return !!section && section.getAttribute('data-pv-taille') === 'attente'; }
  function nomOption(groupe) {
    var lab = groupe && groupe.querySelector('.label-text');
    return lab ? lab.textContent.replace(/[:\s]+$/, '').trim() : '';
  }
  /* texte affiche d'une taille : la valeur du bouton radio est l'identifiant de la variante,
     le texte (S, M, XL) est porte par la pastille voisine */
  function texteTaille(input) {
    var opt = input ? closest(input, '.variant-option') : null;
    var chip = opt ? opt.querySelector('[js-chip]') : null;
    return chip ? String(chip.getAttribute('aria-label') || chip.textContent || '').trim() : '';
  }

  function mettreEnAttente(section) {
    var g = groupeTaille(section);
    if (!g) { return; }
    section.setAttribute('data-pv-taille', 'attente');
    var gs = groupesTaille(section);
    for (var j = 0; j < gs.length; j++) {
      var val = gs[j].querySelector('[js-variant-label-value]');
      if (val && !val.hasAttribute('data-pv-orig')) {
        val.setAttribute('data-pv-orig', val.textContent);
        val.textContent = T.libelle || '';
        val.classList.add('pv-taille-vide');
      }
    }
    /* barre d'achat fixe : la barre elle-meme et l'en-tete de sa fenetre de choix (mobile) */
    var stickies = section.querySelectorAll('[js-sticky-atc] .product-variant-details > div');
    for (var i = 0; i < stickies.length; i++) {
      stickies[i].setAttribute('data-pv-orig', stickies[i].textContent);
      stickies[i].textContent = (nomOption(g) + ' ' + (T.libelle || '')).trim();
    }
  }

  function choisir(section, cible) {
    if (!enAttente(section)) { return; }
    section.removeAttribute('data-pv-taille');
    if (!estApercu(section)) { principaleChoisie = true; }
    var valeur = '';
    if (cible) {
      var input = cible.matches && cible.matches('[js-variant-input]') ? cible : null;
      if (!input && cible.getAttribute && cible.getAttribute('for')) { input = doc.getElementById(cible.getAttribute('for')); }
      if (!input) { input = closest(cible, '.variant-option') ? closest(cible, '.variant-option').querySelector('[js-variant-input]') : null; }
      if (input) { valeur = texteTaille(input); }
    }
    var gs = groupesTaille(section);
    for (var j = 0; j < gs.length; j++) {
      var val = gs[j].querySelector('[js-variant-label-value]');
      if (val) {
        val.textContent = valeur || val.getAttribute('data-pv-orig') || val.textContent;
        val.classList.remove('pv-taille-vide');
        val.removeAttribute('data-pv-orig');
      }
      gs[j].classList.remove('pv-taille-alerte');
      var msg = gs[j].querySelector('.pv-taille-msg');
      if (msg) { msg.remove(); }
    }
    /* barre fixe : son texte d'origine est celui de la variante cochee ; Eclipse le remplace
       lui-meme si la variante change */
    var stickies = section.querySelectorAll('[js-sticky-atc] .product-variant-details > div[data-pv-orig]');
    for (var i = 0; i < stickies.length; i++) { stickies[i].textContent = stickies[i].getAttribute('data-pv-orig'); }
  }

  function alerter(section, cible) {
    var g = cible || groupeTaille(section);
    if (!g) { return; }
    var msg = g.querySelector('.pv-taille-msg');
    if (!msg) {
      msg = doc.createElement('p');
      msg.className = 'pv-taille-msg';
      msg.setAttribute('role', 'alert');
      g.appendChild(msg);
    }
    msg.textContent = '';
    g.classList.remove('pv-taille-alerte');
    void g.offsetWidth;
    g.classList.add('pv-taille-alerte');
    /* nouveau texte a chaque essai, pour que le lecteur d'ecran l'annonce encore ; puis le
       selecteur est ramene a l'ecran s'il le faut, dans la page comme dans l'apercu rapide
       (marges de defilement dans pavenrod-parcours.css : en-tete fixe en haut, boutons d'achat
       colles en bas de l'apercu) */
    setTimeout(function () {
      msg.textContent = T.message || '';
      try { g.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) { g.scrollIntoView(false); }
    }, 30);
    var premier = g.querySelector('[js-variant-input]');
    if (premier && premier.focus) {
      try { premier.focus({ preventScroll: true }); } catch (e) { premier.focus(); }
    }
  }

  function preparer(section) {
    if (section.getAttribute('data-pv-init')) { return; }
    section.setAttribute('data-pv-init', '1');
    if (!T.actif) { return; }
    if (!estApercu(section) && principaleChoisie) { return; }
    mettreEnAttente(section);
  }

  if (T.actif) {
    /* un changement de variante (clic, clavier) vaut choix */
    doc.addEventListener('product:variant:changing', function (e) {
      var s = closest(e.target, '[js-product-section]');
      if (s) { choisir(s, e.detail && e.detail.newOptionInput); }
    }, true);
    /* clic sur la taille deja cochee par Eclipse : aucun changement de variante, mais c'est un choix */
    doc.addEventListener('click', function (e) {
      var c = closest(e.target, '[js-variant-group-container] [js-variant-input], [js-variant-group-container] label, [js-variant-group-container] [js-chip]');
      if (!c) { return; }
      var s = closest(c, '[js-product-section]');
      if (enAttente(s) && estGroupeTaille(closest(c, '[js-variant-group-container]'))) { choisir(s, c); }
    }, true);
    /* ajout au panier par le formulaire (bouton principal, barre fixe, apercu rapide). Depuis la
       barre d'achat fixe, c'est sa fenetre de choix de taille qui s'ouvre, avec le message. */
    doc.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches("form[action*='/cart/add']")) { return; }
      var s = closest(f, '[js-product-section]');
      if (!enAttente(s)) { return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      var cible = null;
      var barre = e.submitter ? closest(e.submitter, '[js-sticky-atc]') : null;
      var fenetre = barre ? barre.querySelector("[data-fluco-dialog='sticky-add-to-cart-modal']") : null;
      if (fenetre) {
        var gs = groupesTaille(s);
        for (var i = 0; i < gs.length; i++) { if (fenetre.contains(gs[i])) { cible = gs[i]; } }
        if (cible && !fenetre.open) {
          window.dispatchEvent(new CustomEvent('fluco:modal:sticky-add-to-cart-modal:open'));
        }
      }
      alerter(s, cible);
    }, true);
    /* modules pack et tenue de la fiche (ajout par script) */
    doc.addEventListener('click', function (e) {
      var b = closest(e.target, '#pvr-pack-add, #pvr-tenue-add');
      if (!b) { return; }
      var s = closest(b, '[js-product-section]');
      if (!enAttente(s)) { return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      alerter(s);
    }, true);
  }

  /* ---------- 2. Alerte de retour en stock par taille ---------- */
  function attente() {
    var bloc = doc.querySelector('[data-pv-attente]');
    if (!bloc || bloc.getAttribute('data-pv-attente-init')) { return; }
    bloc.setAttribute('data-pv-attente-init', '1');
    var variantes = [];
    try { variantes = JSON.parse((bloc.querySelector('[data-pv-attente-variantes]') || {}).textContent || '[]'); } catch (e) { variantes = []; }
    if (!variantes.length || !variantes.some(function (v) { return v.a; })) { return; }
    var titre = bloc.querySelector('[data-pv-attente-titre]');
    var tags = bloc.querySelector('[data-pv-attente-tags]');
    var base = tags ? (tags.getAttribute('data-base') || tags.value) : '';
    var modele = bloc.getAttribute('data-pv-titre-taille') || '';
    var poste = /[?&]customer_posted=true/.test(location.search) && location.hash === '#pvr-waitlist-form';
    if (poste) { bloc.hidden = false; }
    function parId(id) { for (var i = 0; i < variantes.length; i++) { if (String(variantes[i].id) === String(id)) { return variantes[i]; } } return null; }
    function parTitre(t) { for (var i = 0; i < variantes.length; i++) { if (variantes[i].t === t) { return variantes[i]; } } return null; }
    function montrer(v) {
      if (poste) { return; }
      if (!v || v.a) { bloc.hidden = true; return; }
      if (titre && modele) { titre.textContent = modele.replace('[taille]', v.t); }
      if (tags) { tags.value = base + ',taille-' + slug(v.t); }
      bloc.hidden = false;
    }
    var m = /[?&]variant=(\d+)/.exec(location.search);
    if (m) { montrer(parId(m[1])); }
    doc.addEventListener('product:variant:changing', function (e) {
      var s = closest(e.target, '[js-product-section]');
      if (!s || !s.contains(bloc)) { return; }
      /* la valeur du bouton radio est l'identifiant de la variante ; le titre sert de repli */
      var inp = e.detail && e.detail.newOptionInput;
      if (inp && inp.value) { montrer(parId(inp.getAttribute('data-variant-id') || inp.value) || parTitre(texteTaille(inp)) || parTitre(inp.value)); }
    }, true);
  }

  function init() {
    var ss = doc.querySelectorAll('[js-product-section]');
    for (var i = 0; i < ss.length; i++) { preparer(ss[i]); }
    attente();
  }
  if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', init); } else { init(); }

  /* apercu rapide des collections et sections rechargees : preparees a leur arrivee */
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].addedNodes;
        for (var j = 0; j < n.length; j++) {
          if (n[j].nodeType !== 1) { continue; }
          if (n[j].matches && n[j].matches('[js-product-section]')) { preparer(n[j]); }
          var ins = n[j].querySelectorAll ? n[j].querySelectorAll('[js-product-section]') : [];
          for (var k = 0; k < ins.length; k++) { preparer(ins[k]); }
        }
      }
    }).observe(doc.documentElement, { childList: true, subtree: true });
  }
})();
